import { lazy } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import PrivateRoute from './PrivateRoute';


const Login = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const Employee = Loadable(lazy(() => import('views/master/Employee')));
const Acess = Loadable(lazy(() => import('views/master/Acess')));
const Department = Loadable(lazy(() => import('views/master/Department')));
const Organization = Loadable(lazy(() => import('views/master/Organization')));
const WorkRequest = Loadable(lazy(() => import('views/transaction/WorkRequest')));
const FinanceLoanLandingPage = Loadable(lazy(() => import('views/landing/LandingPage')));
const TermsofUse = Loadable(lazy(() => import('views/landing/TermsOfUse')));
const PrivacyPolicy = Loadable(lazy(() => import('views/landing/Privacypolicy')));
const FAQsSection = Loadable(lazy(() => import('views/landing/FAQ')));
const Settings = Loadable(lazy(() => import('views/master/Settings')));
const Role = Loadable(lazy(() => import('views/master/Role')));
const NotificationScreen = Loadable(lazy(() => import('views/master/Notification')));
const AddRequestModal = Loadable(lazy(() => import('views/transaction/AddRequestModal')));
const EditRequestModal = Loadable(lazy(() => import('views/transaction/EditRequestModal')));
const ForgotPassword = Loadable(lazy(() => import('views/pages/authentication/auth-forms/ForgetPassword')));
const DownloadResources = Loadable(lazy(() => import('views/landing/DownloadResources')));
const Demo = Loadable(lazy(() => import('views/landing/demo')));
const ViewDocumentPage = Loadable(lazy(() => import('store/ViewDocumentPage')));
const NotFound = Loadable(lazy(() => import('store/NotFound')));
const InsufficientFunds = Loadable(lazy(() => import('store/InsufficientFunds')));
const UpgradePlanCard = Loadable(lazy(() => import('../layout/MainLayout/Header/ProfileSection/UpgradePlanCard')));
const ApiLogSummary = Loadable(lazy(() => import('views/reports/ApiLogSummary')));
const ApplicationByUser = Loadable(lazy(() => import('views/reports/ApplicationByUser')));
const ApplicationByType = Loadable(lazy(() => import('views/reports/ApplicationByType')));
const ApplicationSummary = Loadable(lazy(() => import('views/reports/ApplicationSummary')));
const PaymentHistory = Loadable(lazy(() => import('views/paymentHistory/PaymentHistory')));
const Widget = Loadable(lazy(() => import('views/master/Widget')));
//const DashBoard = Loadable(lazy(() => import('views/dashboard/Dashboard')));
const DashBoard = Loadable(lazy(() => import('views/staticDashboard/Dashbaord')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: <FinanceLoanLandingPage />
        },
        {
            path: 'login',
            element: <Login />
        },
        {
            path: 'termsofUse',
            element: <TermsofUse />
        },
        {
            path: 'privacy-policy',
            element: <PrivacyPolicy />
        },
        {
            path: 'forgot-password',
            element: <ForgotPassword />
        },
        {
            path: 'faq',
            element: <FAQsSection />
        },
        {
            path: 'DownloadResources',
            element: <DownloadResources />
        },
        {
            path: 'demo',
            element: <Demo />
        },
        {
            path: 'view',
            element: <ViewDocumentPage />
        },
        {
            path: 'notfound',
            element: <NotFound />
        },
        {
            path: 'upgrade/plans',
            element: <UpgradePlanCard />
        },
        {
            path: 'insufficient-funds',
            element: <InsufficientFunds />
        },
        {
            path: 'trucred',
            element: (
                <PrivateRoute>
                    <MainLayout />
                </PrivateRoute>
            ),
            children: [
                {
                    path: 'dashboard',
                    element: <DashBoard />
                },

                {
                    path: 'employee',
                    element: <Employee />
                },
                {
                    path: 'acess',
                    element: <Acess />
                },
                {
                    path: 'branch',
                    element: <Department />
                },
                {
                    path: 'companyprofile',
                    element: <Organization />
                },
                {
                    path: 'workRequest',
                    element: <WorkRequest />
                },

                {
                    path: 'settings',
                    element: <Settings />
                },

                {
                    path: 'role',
                    element: <Role />
                },
                {
                    path: 'notification',
                    element: <NotificationScreen />
                },
                {
                    path: 'add-request',
                    element: <AddRequestModal />
                },
                {
                    path: 'edit-request',
                    element: <EditRequestModal />
                },
                {
                    path: 'apiLogSummary',
                    element: <ApiLogSummary />
                },
                {
                    path: 'applicationByUser',
                    element: <ApplicationByUser />
                },
                {
                    path: 'applicationByType',
                    element: <ApplicationByType />
                },
                {
                    path: 'applicationSummary',
                    element: <ApplicationSummary />
                },
                {
                    path: 'paymentHistory',
                    element: <PaymentHistory />
                },
                {
                    path: 'widget',
                    element: <Widget />
                }
            ]
        }
    ]
};

export default MainRoutes;
